var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CampoRelacionamentoCadastroRapido',{attrs:{"id":_vm.name,"url":"cfopscidades","cadastro-url":"cadastro.CfopCidade","item-text":_vm.formatCfopCidade,"label":_vm.label},on:{"change":_vm.emit},model:{value:(_vm.selecionado),callback:function ($$v) {_vm.selecionado=$$v},expression:"selecionado"}})
}
var staticRenderFns = []

export { render, staticRenderFns }